import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import http from '../api/http';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);     // { id, name, role } | null
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      await http.get('/api/auth/csrf'); // гарантируем XSRF cookie
      const { data } = await http.get('/api/auth/me');
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  // роль/профиль могли смениться на сервере — подтягиваем при возврате на вкладку
  useEffect(() => {
    const onVis = () => {
      if (document.visibilityState === 'visible') fetchMe();
    };
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, [fetchMe]);

  const login = async (email, password) => {
    await http.post('/api/auth/login', { email, password });
    await fetchMe();
  };

  const register = async (payload) => {
    // письмо подтверждения — сессия после verify-email
    return http.post('/api/auth/register', payload).then((r) => r.data);
  };

  const logout = async () => {
    await http.post('/api/auth/logout');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshMe: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
